import { Icon as _Icon } from '@chakra-ui/core';
// import * as React from 'react'
// import upperFirst from 'lodash.upperfirst'
// import * as icons from './lib'
// import css from '@styled-system/css'

// type Props = {
//     desc?: string
//     name: string
//     title?: string
// }

// const Icon = (props: any) => {
//     const {
//         name,
//         title,
//         desc,
//         ...rest
//     } = props

//     let adjustedName = name
//     if (/-/.test(name)) {
//         adjustedName = name.split('-').map((s: string) => upperFirst(s)).join('')
// 	}

//     const Component = icons[adjustedName] || icons[upperFirst(adjustedName)]
//     if (!Component) return null

//     const allowedStyleKeys = ['width', 'height', 'fill', 'stroke']
//     const style = Object.keys(rest).filter((key) => {
//         return allowedStyleKeys.indexOf(key) !== -1
//     }).reduce((result: any, key: string) => {
//         result[key] = rest[key]
//         return result
//     }, {})

//     return (
//         <Component
//             title={title}
//             desc={desc}
//             {...rest}
//         />
//     )
// }

const Icon = _Icon;

Icon.displayName = 'Icon';

export default Icon;
